var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 9.33341C8.35361 9.33341 8.69275 9.19294 8.9428 8.94289C9.19285 8.69284 9.33332 8.3537 9.33332 8.00008C9.33332 7.64646 9.19285 7.30732 8.9428 7.05727C8.69275 6.80722 8.35361 6.66675 7.99999 6.66675C7.64637 6.66675 7.30723 6.80722 7.05718 7.05727C6.80713 7.30732 6.66666 7.64646 6.66666 8.00008C6.66666 8.3537 6.80713 8.69284 7.05718 8.94289C7.30723 9.19294 7.64637 9.33341 7.99999 9.33341Z",
    stroke: "#5F6B88",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.99992C12.8887 11.1113 10.6667 12.6666 8.00001 12.6666C5.33334 12.6666 3.11134 11.1113 1.33334 7.99992C3.11134 4.88859 5.33334 3.33325 8.00001 3.33325C10.6667 3.33325 12.8887 4.88859 14.6667 7.99992Z",
    stroke: "#5F6B88",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGray);
export default __webpack_public_path__ + "static/media/eye-gray.40cef11ef771ed7c5e48123b76683eda.svg";
export { ForwardRef as ReactComponent };